import type { GraphIssue } from "@velizhanin-dev/bot-scenario"

/** Проблемы проверки графа по пути поля конфига (buttons.2.url); nested: вместе с вложенными. */
export function issuesAt(issues: GraphIssue[], path: string, nested = false): GraphIssue[] {
	return issues.filter(
		(issue) => issue.path === path || (nested && issue.path?.startsWith(`${path}.`)),
	)
}
